module.exports = __webpack_public_path__ + "img/logout.462888f6.svg";